import { useState, useEffect } from 'react';
import { API } from 'aws-amplify';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { getMifiel_ProfileInv } from 'src/graphql/customized_queries';
import { Contracts, ContractNull } from './contractInfo.styles';

export default function ContractsInfo() {
  const [dataMifiel, setDataMifiel] = useState({});
  const [signed, setSigned] = useState({});
  const user = useSelector((state) => state.user.currentUser);
  const [widgetId, setWidgetId] = useState({});
  const navigate = useNavigate();

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const { data } = await API.graphql({
          query: getMifiel_ProfileInv,
          variables: { id: `${user.id}_evidenceOfRisks` }
        });
        setDataMifiel(data?.getMifiel);
        let widgetId =
          data?.getMifiel?.signers && data?.getMifiel?.signers.length > 0
            ? data?.getMifiel?.signers[0].widget_id
            : null;
        setWidgetId(data?.getMifiel?.signers[0].widget_id);
        setSigned(data?.getMifiel?.signed);
      } catch (error) {
        console.error(error);
      }
    };
    if (user.id) {
      fetchUserData();
    }
  }, [user.id]);

  const handleSign = () => {
    navigate('/inversionista/dashboard/miFiel', { state: { widgetId } });
  };
  return (
    <Contracts>
      {dataMifiel ? (
        <div>
          <div>
            <p>{dataMifiel && dataMifiel.name ? dataMifiel.name : '-'}</p>
            <p>
              <a
                href={`https://finsphera-webapp-resources.s3.amazonaws.com/${user.id}_invConCom.pdf`}
                target="_blank"
                rel="noopener noreferrer"
              >
                Contrato de crédito
              </a>
            </p>
            {signed ? <></> : <button onClick={handleSign}>Firmar</button>}
            <p>Fecha de firma:</p>
            <p>{dataMifiel && dataMifiel.signed_at ? dataMifiel.signed_at : '-'}</p>
          </div>
        </div>
      ) : (
        <ContractNull>
          <h1>Aún no tienes contratos</h1>
        </ContractNull>
      )}
    </Contracts>
  );
}
